// extracted by mini-css-extract-plugin
export var orderDetails = "_sj-2";
export var orderImage = "_sj-1";
export var orderMeta = "_sj-3";
export var orderSummary = "_sj-0";
export var rightArrow = "_sj-4";